import * as React from 'react';
import { Box, Typography } from '@mui/material';
import { ReactComponent as NotFoundImage } from '@icons/images/not-found.svg';

const UserNotFound: React.FC = () => {
  return (
    <Box display="flex" flexDirection="column" flexGrow={1} p={6}>
      <Box alignItems="center" display="flex" justifyContent="center">
        <Typography textAlign="center" variant="subtitle1">
          Person fetch failed. Please check if &quot;Person ID&quot; specified
          correctly in Zendesk Contact Details tab and you logged in as correct
          user
        </Typography>
      </Box>
      <Box display="flex" justifyContent="center" mt={6}>
        <NotFoundImage />
      </Box>
    </Box>
  );
};

export default UserNotFound;
